import { BenefitEnvironment } from '@mattrika/benefit-core'

export const environment: BenefitEnvironment = {
    appName: 'Chakrijibi Club Dev',
    production: false,
    clientUrl: 'https://dev.chakrijibiclub.com',
    apiUrl: 'https://api-dev.chakrijibiclub.com',
}
